import { Flex } from '@chakra-ui/react';
import {
  faArrowLeft,
  faScrewdriverWrench,
} from '@fortawesome/free-solid-svg-icons';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';
import { ModalLayout } from '@ui/components/layout/ModalLayout';
import { Navigation } from '@ui/components/layout/Navigation';
import { WithPermission } from '@ui/components/Permission';
import { Router } from '@ui/config/routes';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

export function MetricsLayout() {
  return (
    <>
      <ModalLayout />

      <Flex direction="row">
        <Navigation.Menu>
          <Navigation.Item
            label="Back to SNAP"
            path={Router.path(Router.routes.root)}
            icon={faArrowLeft}
          />

          <WithPermission minimumRole={Router.routes.admin.minimumRole}>
            <Navigation.Item
              label="Admin"
              path={Router.path(Router.routes.admin)}
              icon={faScrewdriverWrench}
            />
          </WithPermission>
          <Navigation.ResourceHubLink />
        </Navigation.Menu>

        {/* @NOTE(shawk): ensure <NavigationBar /> stays visible
            while descendent lazy-loaded routes are loading */}
        <Suspense fallback={<FullScreenLoader />}>
          <Outlet />
        </Suspense>
      </Flex>
    </>
  );
}
